import { createContext, useContext, useState, useEffect } from 'react';
import api, { getImageUrl } from '../services/api';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
    } catch (err) {
      console.error('Settings fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // CSS değişkenlerini güncelle
  useEffect(() => {
    if (settings.primary_color) {
      document.documentElement.style.setProperty('--primary', settings.primary_color);
      // primary-dark hesapla (biraz koyu versiyon)
      const hex = settings.primary_color.replace('#', '');
      const r = Math.max(0, parseInt(hex.substring(0, 2), 16) - 25);
      const g = Math.max(0, parseInt(hex.substring(2, 4), 16) - 25);
      const b = Math.max(0, parseInt(hex.substring(4, 6), 16) - 25);
      document.documentElement.style.setProperty('--primary-dark', `rgb(${r},${g},${b})`);
    }
    if (settings.secondary_color) {
      document.documentElement.style.setProperty('--secondary', settings.secondary_color);
    }
  }, [settings.primary_color, settings.secondary_color]);

  // Favicon güncelle
  useEffect(() => {
    if (settings.favicon_path) {
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.href = getImageUrl(settings.favicon_path);
      document.head.appendChild(link);
    }
  }, [settings.favicon_path]);

  // Sayfa başlığını güncelle
  useEffect(() => {
    if (settings.site_title) {
      document.title = settings.site_title;
    }
  }, [settings.site_title]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refetchSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}
